import React, { Component, ReactNode } from 'react';

interface Props {
  children: ReactNode;
  fallback?: ReactNode;
}

interface State {
  hasError: boolean;
  error?: Error;
}

export class ErrorBoundary extends Component<Props, State> {
  constructor(props: Props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError(error: Error): State {
    return { hasError: true, error };
  }

  componentDidCatch(error: Error, errorInfo: React.ErrorInfo) {
    console.error('ErrorBoundary caught an error:', error, errorInfo);
  }

  render() {
    if (this.state.hasError) {
      return this.props.fallback || (
        <div className="h-screen bg-[#1a1a1a] flex items-center justify-center">
          <div className="text-center">
            <h2 className="text-xl text-white mb-4">Something went wrong</h2>
            <p className="text-gray-400 mb-4">Please refresh the page to try again</p>
            <button
              onClick={() => window.location.reload()}
              className="bg-gradient-to-br from-[#79c9cb] to-[#4b7bdd] text-black px-4 py-2 rounded-lg hover:opacity-90 transition-opacity"
            >
              Refresh Page
            </button>
          </div>
        </div>
      );
    }

    return this.props.children;
  }
}
